/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import type { LocationDtoDistrictId } from './locationDtoDistrictId';
import type { LocationDtoRegionId } from './locationDtoRegionId';
import type { LocationDtoType } from './locationDtoType';

export interface LocationDto {
  id: string;
  name: string;
  type: LocationDtoType;
  /** @nullable */
  regionId: LocationDtoRegionId;
  /** @nullable */
  districtId: LocationDtoDistrictId;
  slug: string;
}
